import React from 'react';
import TecnicosList from '../../components/tecnicos/TecnicosList';

const TecnicosPage: React.FC = () => {
  return <TecnicosList />;
};

export default TecnicosPage;
